export default __webpack_public_path__ + "static/Poppins-Regular-8081832fc5cfbf634aa664a9eff0350e.ttf";